module.exports = __webpack_public_path__ + "./images/c5db42c43e99ed5a4cb5e002c138e720.webp";